import React from 'react';
import { SvgIcon } from '@mui/material';

function NewSectionIcon({ fill = '#0194D3'}) {
  return (
    <SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clip-path="url(#clip0_11742_17939)">
        <path d="M21 12L16.63 18.16C16.26 18.68 15.65 19 15 19H12V17H15L18.55 12L15 7H5V10H3V7C3 5.9 3.9 5 5 5H15C15.65 5 16.26 5.31 16.63 5.84L21 12ZM10 15H7V12H5V15H2V17H5V20H7V17H10V15Z" fill={fill} />
      </g>
      <defs>
        <clipPath id="clip0_11742_17939">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>

    </SvgIcon>
  );
}

export default NewSectionIcon;
